export default __webpack_public_path__ + "static/media/Guru-Parampara-14.35222cfe.png";